import { styled } from 'styled-components';

export const StagePage = styled.div`
  padding: 20px;
  color: #2d3748;
  width: 100%;

  h2 {
    color: #2d3748;
    font-weight: 600;
  }
`;

export const LoadStageContainer = styled.div`
  max-width: 600px;
  margin: 40px auto;
  padding: 30px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
`;

export const LoadStageTitle = styled.h2`
  margin-bottom: 20px;
  font-size: 24px;
  color: #2d3748;
`;

export const SelectGroup = styled.div`
  margin-bottom: 20px;
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #cbd5e0;
  border-radius: 5px;
  background-color: #ffffff;
  color: #2d3748;

  &:focus {
    outline: none;
    border-color: #4299e1;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
`;

export const LoadButton = styled.button`
  flex: 1;
  padding: 10px 20px;
  background-color: #4299e1;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #3182ce;
  }

  &:disabled {
    background-color: #cbd5e0;
    cursor: not-allowed;
  }
`;

export const NewStageButton = styled.button`
  flex: 1;
  padding: 10px 20px;
  background-color: #10b981;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #059669;
  }
`;

export const ActionBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  margin-bottom: 10px;
`;

export const ActionGroup = styled.div`
  display: flex;
  gap: 10px;
`;

export const SaveIndicator = styled.div<{ $saved: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  background-color: ${props => props.$saved ? '#d1fae5' : '#fef3c7'};
  color: ${props => props.$saved ? '#065f46' : '#92400e'};
`;

export const PrimaryButton = styled.button`
  padding: 10px 20px;
  background-color: #4299e1;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #3182ce;
  }
`;

export const SecondaryButton = styled.button`
  padding: 10px 20px;
  background-color: #e2e8f0;
  color: #2d3748;
  font-weight: 600;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #cbd5e0;
  }
`;

export const DangerButton = styled.button`
  padding: 10px 20px;
  background-color: #ef4444;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #dc2626;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  color: #2d3748;
  font-weight: 500;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #cbd5e0;
  border-radius: 5px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #4299e1;
  }
`;

export const NumberInput = styled.input.attrs({ type: 'number' })`
  width: 150px;
  padding: 10px;
  border: 1px solid #cbd5e0;
  border-radius: 5px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #4299e1;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 400px;
  padding: 10px;
  border: 1px solid #cbd5e0;
  border-radius: 5px;
  font-size: 14px;
  font-family: 'Courier New', monospace;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #4299e1;
  }
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  margin-right: 8px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  color: #2d3748;
  font-weight: 400;
  cursor: pointer;
`;

export const Fieldset = styled.fieldset`
  border: 1px solid #cbd5e0;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 20px;

  legend {
    padding: 0 10px;
    color: #2d3748;
    font-weight: 600;
  }
`;
